import { render, staticRenderFns } from "./unauthorized-layout.vue?vue&type=template&id=5b79b5b0&lang=pug"
import script from "./unauthorized-layout.vue?vue&type=script&lang=js"
export * from "./unauthorized-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports